<template>
  <!--
    Kontener tabeli kategorii pojazdów, stylizowany według aktualnego kroku (step).
    Widoczny tylko, gdy są wybrane kategorie w store.filters.ctg8p1.
  -->
  <div class="vehicle-categories" :class="`step-${step}`">
    <!--
      Nagłówek tabeli: wyświetla przetłumaczony tekst 'vehicle-categories' wielkimi literami
      oraz informację (8+1) o liczbie kategorii.
    -->
    <h3 class="margin-0">
      {{ t('vehicle-categories').toUpperCase() }} (8+1)
    </h3>
    
    <!--
      Tabela kategorii: każda kolumna odpowiada jednej kategorii pojazdu.
      Klasa dynamiczna 'step-{step}' umożliwia różnicowanie stylu między krokami.
    -->
    <table class="category-table" :class="`step-${step}`">
      <thead>
        <tr>
          <!-- Nagłówki kolumn generowane na podstawie store.vehicleCategories -->
          <th
            v-for="(item, index) in store.vehicleCategories"
            :key="'th-' + index"
          >
            <!-- Gdy nazwa kategorii to 'lack', wyświetlamy tłumaczenie klucza 'lack', w przeciwnym wypadku samą nazwę -->
            {{ item === 'lack' ? t('lack') : item }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <!-- Wiersz z checkboxami: pozwalają zaznaczyć/odznaczyć kategorie -->
          <td
            v-for="(item, index) in store.vehicleCategories"
            :key="'cb-' + index"
          >
            <input-checkbox
              :field-name="index"
              field-value=""
              :checkedCondition="isChecked(index)"
              @clicked="setFilter(index)"
            />
          </td>
        </tr>
        <!--
          Ostatni wiersz: wyświetla ikonę dla każdej kategorii.
          Dodatkowa klasa 'with-border-left' gdy jest tylko jedna lokalizacja.
        -->
        <tr class="last" :class="{ 'with-border-left': this.store.locations.length == 1 }">
          <td
            v-for="(item, index) in store.vehicleCategories"
            :key="'icon-' + index"
            :class="'icon-' + item"
          ></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// Import InputCheckbox: komponent reprezentujący pojedynczy checkbox
import InputCheckbox from "../InputCheckbox.vue";
// Hook tłumaczeń z vue-i18n
import { useI18n } from 'vue-i18n';

export default {
  name: "VehicleCategories",  // Nazwa komponentu dla Vue DevTools
  props: {
    // Store Pinia: przechowuje dane kategorii i obiekty filtrów
    store: { required: true },
    // Aktualny krok wyświetlania, używany do nadawania klas CSS
    step: { type: Number, default: 1 },
  },
  created() {
    // Pobranie listy lokalizacji w celu warunkowego stylowania tabeli
    this.store.getLocations();
  },
  components: { 
    InputCheckbox, // Rejestracja komponentu InputCheckbox
  },
  setup() {
    // Funkcja tłumaczenia dostępna jako this.t
    const { t } = useI18n();
    return { t };
  },
  methods: {
    /**
     * Przełącza filtr kategorii:
     * - Dodaje lub usuwa kategorię o danym indeksie w liście vehicleCategories
     * @param {number} index - pozycja kategorii w tablicy
     */
    setFilter(index) {
      this.store.addItem("VehicleCategories", index);
    },
     /**
     * Sprawdza, czy kategoria jest aktualnie zaznaczona:
     * - Wyszukuje nazwę kategorii pod indeksem w filtrach ctg8p1
     * @param {number} id - indeks kategorii
     * @returns {boolean}
     */
    isChecked(id) {
      return (
        this.store.filters.ctg8p1 &&
        this.store.filters.ctg8p1.includes(this.store.vehicleCategories[id])
      );
    },
  },
};
</script>

<style scoped>
/* Styl kontenera tabeli w kroku 1 */
.vehicle-categories.step-1 {
  width: 400px;
}

/* Styl kontenera tabeli w kroku 2 */
.vehicle-categories.step-2 {
  width: 500px;
  border-bottom: 1px solid #bfbfbf;
}

/* Nagłówek (h3) - wspólne obramowania dla obu kroków */
.vehicle-categories.step-1 h3,
.vehicle-categories.step-2 h3 {
  padding: 0.85rem 1rem 0.9rem 1rem;
  width: 100%;
  border-right: 1px solid #bfbfbf;
  border-bottom: 1px solid #bfbfbf;
  border-top: 1px solid #bfbfbf;
}

/* .vehicle-categories.step-1 h3 {
  padding: 0.85rem 1rem 0.9rem 1rem;
  width: 100%;
  border-right: 1px solid #bfbfbf;
  border-bottom: 1px solid #bfbfbf;
  border-top: 1px solid #bfbfbf;
}

.vehicle-categories.step-2 h3 {
  padding: 0.85rem 1rem 0.9rem 1rem;
  width: 100%;
  border-right: 1px solid #bfbfbf;
  border-bottom: 1px solid #bfbfbf;
  border-top: 1px solid #bfbfbf;
} */

.category-table.step-1 {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  background-color: white;
  table-layout: fixed;
}

th,
td {
  padding: 0.5rem;
  font-size: 12px;
  text-align: center;     
  vertical-align: middle; 
  height: 43px;
}

tr {
  border-right: 1px solid #bfbfbf;
  border-bottom: 1px solid #bfbfbf;
}

.category-table.step-2 {
  width: 500px;
  border-collapse: collapse;
  text-align: center;
  background-color: white;
  table-layout: fixed;
}

.category-table.step-2 th, .category-table.step-2 td {
  padding: 0.5rem;
  font-size: 12px;
  text-align: center;     
  vertical-align: middle; 
  height: 52px;
  border-bottom: 1px solid #bfbfbf;
}

.last {
  border: none;
  border-right: 1px solid #bfbfbf;
  height: 52px;
}

td .container {
  margin-top: 0.40rem;
  padding: 11.5px;
}

[class^="icon-"] {
  background-repeat: no-repeat;
  background-position: center;
}

.with-border-left {
  border-left: 1px solid #bfbfbf;
}
</style>